import { type TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { IconActionArrowLeft16, IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './styles.css';

export interface IVerticalArrowProps {
  direction: TDirection;
  offset?: number;
  containerClass?: string;
  onClick?(): void;
}

const DEFAULT_OFFSET = -20;

export const VerticalArrow: FC<IVerticalArrowProps> = ({
  direction,
  offset = DEFAULT_OFFSET,
  containerClass,
  onClick,
}) => {
  const ArrowIcon = direction < 0 ? IconActionArrowLeft16 : IconActionArrowRight16;
  const style = direction < 0 ? { left: `${offset}px` } : { right: `${offset}px` };

  return (
    <div className={clsx(styles['arrow'], containerClass)} style={style} onClick={onClick}>
      <ArrowIcon color="icon-secondary-default" />
    </div>
  );
};
